import axios from "@/libs/api.request";
export function getPrjectLeftTree(params) {
    return axios.request({
        url: "ErpProject/getProjectTreeNum",
        method: "get",
        params:params,
    })
}
//获取项目节点信息
export function getProjectNodeTree(params) {
    return axios.request({
        url: "ErpProject/getProjectNodeList",
        method: "get",
        params:params,
    })
}